import React, { memo, useState, useRef } from 'react';
import DependencyDropdown from '../../../../shared/DependencyDropdown';

/**
 * WaitingForIndicator - Shows blocking dependencies for a task
 * Displays a clickable indicator that opens a dependency dropdown
 */
const WaitingForIndicator = memo(({
  task,
  allTasks,
  blockingDependencies,
  onDependencyChange,
}) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const buttonRef = useRef(null);

  if (blockingDependencies.length === 0) {
    return null;
  }

  return (
    <>
      <button
        ref={buttonRef}
        className="todo-item__waiting todo-item__waiting--clickable"
        onClick={(e) => {
          e.stopPropagation();
          setShowDropdown(!showDropdown);
        }}
        title="Click to edit dependencies"
      >
        <span className="todo-item__waiting-label">Waiting for</span>
        <span className="todo-item__waiting-value">
          {blockingDependencies.length === 1 
            ? blockingDependencies[0].name 
            : `${blockingDependencies.length} missions`}
        </span>
      </button>
      <DependencyDropdown
        task={task}
        allTasks={allTasks}
        onDependencyChange={onDependencyChange}
        isOpen={showDropdown}
        onClose={() => setShowDropdown(false)}
        anchorRef={buttonRef}
      />
    </>
  );
});

WaitingForIndicator.displayName = 'WaitingForIndicator';

export default WaitingForIndicator;
